import { createSelector } from 'reselect'

const getSearchBoxRulesState = state => state.searchBoxRules

export const getSearchBoxRules = createSelector([getSearchBoxRulesState], state =>
  state && state.data ? state.data.searchBoxRule : null
)

export const getEarliestDate = createSelector([getSearchBoxRules], rules =>
  rules ? rules.dateLimits.earliest : null
)

export const getLatestDate = createSelector([getSearchBoxRules], rules =>
  rules ? rules.dateLimits.latest : null
)

export const getAvailableCabins = createSelector([getSearchBoxRules], rules =>
  rules ? rules.availableCabins : []
)

export const getMinAdt = createSelector([getSearchBoxRules], rules =>
  rules ? rules.passengerLimits.minAdt : 1
)

export const getMinChd = createSelector([getSearchBoxRules], rules =>
  rules ? rules.passengerLimits.minChd : 0
)

export const getMinInf = createSelector([getSearchBoxRules], rules =>
  rules ? rules.passengerLimits.minInf : 0
)

export const getMinPassengersByType = createSelector(
  [getMinAdt, getMinChd, getMinInf],
  (adt, chd, inf) => [adt, chd, inf]
)

export const getMaxAdt = createSelector([getSearchBoxRules], rules =>
  rules ? rules.passengerLimits.maxAdt : 8
)

export const getMaxChd = createSelector([getSearchBoxRules], rules =>
  rules ? rules.passengerLimits.maxChd : 8
)

export const getMaxInf = createSelector([getSearchBoxRules], rules =>
  rules ? rules.passengerLimits.maxInf : 8
)

export const getMaxPassengersByType = createSelector(
  [getMaxAdt, getMaxChd, getMaxInf],
  (adt, chd, inf) => [adt, chd, inf]
)

export const getMaxPassengers = createSelector([getSearchBoxRules], rules =>
  rules ? rules.passengerLimits.maxPassengers : 9
)

export const getMaxInfPerAdt = createSelector([getSearchBoxRules], rules =>
  rules ? rules.passengerLimits.maxInfPerAdt : 1
)

export const getPromoCodeEnabled = createSelector([getSearchBoxRules], rules =>
  rules ? rules.promoCodeEnabled : true
)

export const getDefaultFlightType = createSelector(
  [getSearchBoxRules],
  rules => rules && rules.flightTypeDefault
)
